export default __webpack_public_path__ + "static/media/M. Domo.7984a3fc.png";